module.exports = __webpack_public_path__ + "static/anne-pitman-bio-80c5dac80030c5c815f689a0cdd1b0df.jpg";